import React from 'react';
import {useIntl} from 'react-intl';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';
import Typography from 'brandComponents/Typography';

import {IStep3Props} from './IStep3';
import messages from './messages';

import returnCreateFormStyles from '../../ReturnAuthorizationCreateForm.module.scss';
import styles from './Step3.module.scss';

const Step3 = ({handleSuccess}: IStep3Props) => {
	const intl = useIntl();

	return (
		<div className={styles['return-create-step-3']}>
			<div className={styles['return-create-step-3__svg-wrapper']}>
				<Icon name="check" width={35} height={35} />
			</div>

			<Typography variant="h2" classNames={styles['return-create-step-3__title']}>
				{intl.formatMessage(messages.title)}
			</Typography>
			<Typography variant="p" classNames={styles['return-create-step-3__description']}>
				{intl.formatMessage(messages.emailInstructions)}
			</Typography>
			<Typography variant="ol" classNames={styles['return-create-step-3__description']}>
				<li className={styles['return-create-step-3__instruction']}>{intl.formatMessage(messages.instruction1)}</li>
				<li className={styles['return-create-step-3__instruction']}>{intl.formatMessage(messages.instruction2)}</li>
				<li className={styles['return-create-step-3__instruction']}>{intl.formatMessage(messages.instruction3)}</li>
			</Typography>
			<Button
				variant="primary"
				classNames={returnCreateFormStyles['return-create__form-apply']}
				onClick={handleSuccess}
			>
				{intl.formatMessage(messages.continueButton)}
			</Button>
		</div>
	);
};

export default Step3;
